// -------------------------------------------------    -------------------------
// # - Reveal content
// --------------------------------------------------------------------------
// Author:      Zone
// Email:       frontend@zonedigital.com
// URL:         http://zonedigital.com
// Copyright:   Copyright (c) 2017, zonedigital.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------
'use strict';

module.exports = function (options) {
    var ref = { $root: options.context };
    var state = { open: false };
    var openCssClass = 'open';
    var closedStateText;
    var openedStateText;

    function render() {
        /// render function updates the UI
        var slideDuration = 400;
        ref.$revealContent.toggleClass(openCssClass, state.open);
        ref.$buttonText.text(state.open ? openedStateText : closedStateText);
        state.open ? ref.$revealHiddenWrapper.slideDown(slideDuration) : ref.$revealHiddenWrapper.slideUp(slideDuration);
    }

    function init() {
        // Cache DOM elements
        ref.$revealContent = ref.$root.find('[data-binding="reveal-content-button"]');
        ref.$revealHiddenWrapper = ref.$root.find('[data-binding="reveal-hidden-wrapper"]');
        ref.$revealContentWrapper = ref.$root.find('[data-binding="reveal-content-wrapper"]');
        ref.$buttonText = ref.$revealContent.find('.button__text');
        openedStateText = ref.$revealContent.attr('data-opened-text');
        closedStateText = ref.$buttonText.text();

        /// Events
        ref.$root.on('click', '[data-binding="reveal-content-button"]', function (e) {
            e.preventDefault();

            // Toggle the state.open
            state.open = !state.open;

            // Trigger render
            render();
        });
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/reveal-content.js
// module id = 482
// module chunks = 0